// @ts-nocheck
import React, { Component } from "react";
import { toast } from "react-toastify";
import "./postman-uploader.css";

class PostmanCollectionUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collection: null,
      collectionAuth: null,
      requests: null,
      error: null,
      variables: {},
      selectedRequests: {},
      selectedAll: true,
      fileName: ""
    };
  }

  convertToCamelCase = str => {
    const cleanedStr = str.replace(/[^a-zA-Z0-9\s]/g, "");

    const words = cleanedStr.split(" ").filter(Boolean);

    if (words.length === 0) return "";

    return (
      words[0].toLowerCase() +
      words
        .slice(1)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join("")
    );
  };

  handleFileChange = event => {
    const file = event.target.files[0];

    if (file) {
      this.setState({ fileName: file.name });
      const reader = new FileReader();
      reader.onload = this.handleFileLoad;
      reader.readAsText(file);
    }
  };

  initializeSelectedRequests = (items, defaultValue = true) => {
    const selectedRequests = {};
    items.forEach((_item, index) => {
      selectedRequests[index] = defaultValue;
    });
    return selectedRequests;
  };

  handleCheckboxChange = index => {
    this.setState(prevState => ({
      selectedRequests: {
        ...prevState.selectedRequests,
        [index]: !prevState.selectedRequests[index]
      }
    }));
  };

  generateCurlCommandFromPostman = (postmanRequest, variables) => {
    const method = postmanRequest.method ? postmanRequest.method.toUpperCase() : "GET";

    // Convert Postman {{variable}} to our {variable} format
    let url = postmanRequest.url && postmanRequest.url.raw
      ? this.convertPostmanVariables(postmanRequest.url.raw)
      : "";

    let curlCommand = `curl -X ${method} "${url}"`;

    // Handle auth: apikey, bearer, basic
    const auth = postmanRequest.auth || this.state.collectionAuth;
    if (auth) {
      if (auth.type === "apikey" && auth.apikey) {
        const apiKeyParams = auth.apikey;
        const keyValue = apiKeyParams.find(p => p.key === "value")?.value || "";
        const keyName = apiKeyParams.find(p => p.key === "key")?.value || "";
        const keyLocation = apiKeyParams.find(p => p.key === "in")?.value || "header";
        const resolvedKeyValue = this.replaceVariablesInUrl(keyValue, variables);
        const resolvedKeyName = this.replaceVariablesInUrl(keyName, variables);
        if (keyLocation === "header") {
          curlCommand += ` -H "${resolvedKeyName}: ${resolvedKeyValue}"`;
        } else if (keyLocation === "query") {
          url += (url.includes("?") ? "&" : "?") + `${resolvedKeyName}=${resolvedKeyValue}`;
          curlCommand = `curl -X ${method} "${url}"`;
        }
      } else if (auth.type === "bearer" && auth.bearer) {
        const token = auth.bearer.find(p => p.key === "token")?.value || "";
        curlCommand += ` -H "Authorization: Bearer ${this.replaceVariablesInUrl(token, variables)}"`;
      } else if (auth.type === "basic" && auth.basic) {
        const username = auth.basic.find(p => p.key === "username")?.value || "";
        const password = auth.basic.find(p => p.key === "password")?.value || "";
        curlCommand += ` -u "${this.replaceVariablesInUrl(username, variables)}:${this.replaceVariablesInUrl(password, variables)}"`;
      }
    }

    if (postmanRequest.header && postmanRequest.header.length > 0) {
      postmanRequest.header.forEach(header => {
        if (header.key && header.value) {
          curlCommand += ` -H "${header.key}: ${this.replaceVariablesInUrl(header.value, variables)}"`;
        }
      });
    }

    if (postmanRequest.body) {
      const { mode } = postmanRequest.body;

      if (mode === "graphql" && postmanRequest.body.graphql) {
        let parsedVars = {};
        try {
          if (postmanRequest.body.graphql.variables) {
            parsedVars = JSON.parse(postmanRequest.body.graphql.variables);
          }
        } catch (_) { /* malformed variables JSON — use empty */ }
        const gqlBody = JSON.stringify({
          query: this.convertPostmanVariables(postmanRequest.body.graphql.query || ""),
          variables: parsedVars
        });
        curlCommand += ` -H "Content-Type: application/json" --data-raw '${gqlBody}'`;
      } else if (mode === "raw" && postmanRequest.body.raw) {
        curlCommand += ` --data-raw '${this.replaceVariablesInUrl(postmanRequest.body.raw, variables)}'`;
      } else if (mode === "urlencoded" && postmanRequest.body.urlencoded && postmanRequest.body.urlencoded.length > 0) {
        const formData = postmanRequest.body.urlencoded
          .map(field => `${encodeURIComponent(field.key)}=${encodeURIComponent(field.value)}`)
          .join("&");
        curlCommand += ` --data '${this.replaceVariablesInUrl(formData, variables)}'`;
      } else if (mode === "formdata" && postmanRequest.body.formdata && postmanRequest.body.formdata.length > 0) {
        postmanRequest.body.formdata.forEach(field => {
          curlCommand += ` -F "${field.key}=${this.replaceVariablesInUrl(field.value, variables)}"`;
        });
      }
    }

    return curlCommand;
  };

  replaceVariablesInRequests = (requests, variables) => {
    return requests.map(item => {
      if (item.request) {
        if (item.request.url && item.request.url.raw) {
          item.request.url.raw = this.replaceVariablesInUrl(item.request.url.raw, variables);
        }

        if (item.name) {
          item.name = this.convertToCamelCase(item.name);
        }

        item.curlCommand = this.generateCurlCommandFromPostman(item.request, variables);
      }
      return item;
    });
  };

  flattenRequests = (items, variables) => {
    const allRequests = [];

    const processItem = item => {
      if (item.request) {
        if (item.request.url && item.request.url.raw) {
          item.request.url.raw = this.replaceVariablesInUrl(item.request.url.raw, variables);
        }

        if (item.name) {
          item.name = this.convertToCamelCase(item.name);
        }

        item.curlCommand = this.generateCurlCommandFromPostman(item.request, variables);
        allRequests.push(item);
      }

      if (item.item && Array.isArray(item.item)) {
        item.item.forEach(subItem => processItem(subItem));
      }
    };

    items.forEach(item => processItem(item));
    return allRequests;
  };

  // Convert Postman's {{variable}} syntax to our system's {variable} syntax
  convertPostmanVariables = (text) => {
    if (!text) return "";
    // Replace {{variable}} with {variable} - our system uses single curly braces
    return text.replace(/{{(.*?)}}/g, (_, key) => `{${key}}`);
  };

  replaceVariablesInUrl = (url, variables) => {
    try {
      if (!url) return "";
      // Convert Postman's {{variable}} to our {variable} format
      return this.convertPostmanVariables(url);
    } catch (error) {
      toast.warn("Error processing variables in URL.");
      return url || "";
    }
  };

  withoutVariables = field => {
    if (!field) return "";
    // Convert Postman's {{variable}} to our {variable} format
    return this.convertPostmanVariables(field);
  };

  parseVariables = variableArray => {
    const variables = {};
    if (variableArray) {
      variableArray.forEach(variable => {
        variables[variable.key] = variable.value;
      });
    }
    return variables;
  };

  isValidPostmanCollection = collection => {
    return (
      collection &&
      collection.info &&
      collection.item &&
      collection.info.schema &&
      collection.info.schema.includes("postman")
    );
  };

  generateRequestObjectsFromPostman = requestItem => {
    const { method, url, header, body, auth } = requestItem.request || {};

    const protocol = this.extractProtocol(url);
    const domain = this.extractDomain(url);
    const queryParams = this.extractQueryParams(url);
    const headers = this.extractHeaders(header);
    const { bodyContent, contentType, formData, isGraphql, graphqlQuery, graphqlVariables } = this.extractBody(body);

    // Handle auth — add auth headers (request-level or collection-level fallback)
    // Only add if Authorization header doesn't already exist in explicit headers
    const effectiveAuth = auth || this.state.collectionAuth;
    const hasAuthHeader = headers.some(h => h.key && h.key.toLowerCase() === "authorization");
    if (effectiveAuth && !hasAuthHeader) {
      if (effectiveAuth.type === "bearer" && effectiveAuth.bearer) {
        const token = effectiveAuth.bearer.find(p => p.key === "token")?.value || "";
        headers.push({ key: "Authorization", value: "Bearer " + this.withoutVariables(token) });
      } else if (effectiveAuth.type === "basic" && effectiveAuth.basic) {
        const username = effectiveAuth.basic.find(p => p.key === "username")?.value || "";
        const password = effectiveAuth.basic.find(p => p.key === "password")?.value || "";
        headers.push({ key: "Authorization", value: "Basic " + this.withoutVariables(username + ":" + password) });
      } else if (effectiveAuth.type === "apikey" && effectiveAuth.apikey) {
        const keyValue = effectiveAuth.apikey.find(p => p.key === "value")?.value || "";
        const keyName = effectiveAuth.apikey.find(p => p.key === "key")?.value || "";
        const keyLocation = effectiveAuth.apikey.find(p => p.key === "in")?.value || "header";
        if (keyLocation === "header") {
          headers.push({ key: this.withoutVariables(keyName), value: this.withoutVariables(keyValue) });
        }
      }
    }

    // Extract expected status code from Postman response examples
    let expectedStatusCode = null;
    if (requestItem.response && requestItem.response.length > 0) {
      // Use the first response example's status code
      expectedStatusCode = requestItem.response[0].code || requestItem.response[0].status;
    }

    let rawUrl = (url && url.raw) ? url.raw : "";
    if (rawUrl && !rawUrl.startsWith("http://") && !rawUrl.startsWith("https://")) {
      rawUrl = protocol + "://" + rawUrl;
    }

    return {
      method: (method || "GET").toUpperCase(),
      url: rawUrl,
      headers,
      body: bodyContent,
      params: queryParams,
      protocol,
      domain,
      formData,
      contentType,
      expectedStatusCode,
      isGraphql,
      graphqlQuery,
      graphqlVariables
    };
  };

  extractProtocol = urlObj => {
    return urlObj && urlObj.protocol ? urlObj.protocol : "https";
  };

  removeHttpHttpsAndParams = url => {
    let cleanUrl = url.replace(/^https?:\/\//, "");

    cleanUrl = cleanUrl.split("?")[0];

    return cleanUrl;
  };

  extractDomain = urlObj => {
    return urlObj && urlObj.raw ? this.removeHttpHttpsAndParams(this.withoutVariables(urlObj.raw)) : "";
  };

  extractQueryParams = urlObj => {
    return urlObj && urlObj.query
      ? urlObj.query.map(query => ({ key: query.key, value: this.withoutVariables(query.value) }))
      : [];
  };

  extractHeaders = headerArray => {
    if (!headerArray || headerArray.length === 0) return [];

    return headerArray
      .filter(header => header.key && header.value)
      .map(header => ({ key: header.key, value: this.withoutVariables(header.value) }));
  };

  extractBody = body => {
    if (!body) return { bodyContent: "", contentType: "", formData: [], isGraphql: false, graphqlQuery: "", graphqlVariables: "" };

    const mode = body.mode;
    let bodyContent = "";
    let contentType = "JSON";
    let formData = [];

    // Detect GraphQL mode
    if (mode === "graphql" && body.graphql) {
      return {
        bodyContent: body.graphql.query || "",
        contentType: "JSON",
        formData: [],
        isGraphql: true,
        graphqlQuery: this.convertPostmanVariables(body.graphql.query || ""),
        graphqlVariables: this.convertPostmanVariables(body.graphql.variables || "{}")
      };
    }

    if (mode === "raw" && body.raw) {
      bodyContent = this.withoutVariables(body.raw);
    } else if (mode === "urlencoded" && body.urlencoded) {
      formData = body.urlencoded.map(field => ({
        key: field.key,
        value: this.withoutVariables(field.value),
        type: "Text"
      }));
      contentType = "FORM";
    } else if (mode === "formdata" && body.formdata) {
      formData = body.formdata.map(field => ({
        key: field.key,
        value: this.withoutVariables(field.value),
        type: "Text"
      }));
      contentType = "FORM";
    }

    return { bodyContent, contentType, formData, isGraphql: false, graphqlQuery: "", graphqlVariables: "" };
  };

  handleFileLoad = event => {
    const fileContent = event.target.result;

    try {
      const collectionObject = JSON.parse(fileContent);

      if (this.isValidPostmanCollection(collectionObject)) {
        const variables = this.parseVariables(collectionObject.variable);
        // Store collection-level auth for inheritance by child requests
        const collectionAuth = collectionObject.auth || null;
        const requests = this.flattenRequests(collectionObject.item, variables);

        this.setState({
          collection: collectionObject,
          collectionAuth,
          requests,
          variables,
          error: null,
          selectedRequests: this.initializeSelectedRequests(requests)
        });
      } else {
        toast.error('Invalid Postman Collection: Missing "info" or "item" fields.');
      }
    } catch (error) {
      toast.error("Something went wrong while parsing file. Please try again!");
    }
  };

  handleNameChange = (index, newName) => {
    this.setState(prevState => {
      const updatedRequests = [...prevState.requests];
      updatedRequests[index].name = newName;
      return { requests: updatedRequests };
    });
  };

  createApis() {
    try {
      const { requests, selectedRequests } = this.state;
      const selected = requests.filter((_r, i) => selectedRequests[i]);

      const restApis = [];
      const graphqlApis = [];

      selected.forEach(request => {
        const api = { name: request.name };
        const requestData = this.generateRequestObjectsFromPostman(request);

        if (requestData.isGraphql) {
          // GraphQL request — route to GraphQL bulk create
          graphqlApis.push({
            name: request.name,
            endpointUrl: requestData.url,
            query: requestData.graphqlQuery,
            variables: requestData.graphqlVariables,
            headers: requestData.headers
          });
        } else {
          // REST API request — strip GraphQL-only fields that backend CurlRequest doesn't recognize
          const { isGraphql: _ig, graphqlQuery: _gq, graphqlVariables: _gv, ...restFields } = requestData;
          const curlRequest = {
            ...restFields,
            curlCommand: request.curlCommand,
            expectedStatusCode: requestData.expectedStatusCode
          };
          restApis.push({ api, curlRequest });
        }
      });

      // Extract common headers across all selected REST requests for saved header creation
      const allHeaders = restApis.map(a => a.curlRequest.headers || []);
      const commonHeaders = this.extractCommonHeaders(allHeaders);

      this.props.save(restApis, commonHeaders, graphqlApis);
    } catch (error) {
      toast.error("Error occured while parsing postman collection data.");
      console.error("something went wrong", error);
    }
  }

  // Find headers that appear in >50% of requests — candidates for saved header
  extractCommonHeaders = (allHeaderArrays) => {
    if (!allHeaderArrays || allHeaderArrays.length === 0) return [];
    const freq = {};
    allHeaderArrays.forEach(headers => {
      const seen = new Set();
      headers.forEach(h => {
        if (h.key && !seen.has(h.key)) {
          freq[h.key] = (freq[h.key] || 0) + 1;
          seen.add(h.key);
        }
      });
    });
    const threshold = allHeaderArrays.length / 2;
    const common = [];
    for (const [key, count] of Object.entries(freq)) {
      if (count > threshold) {
        // Use value from first request that has this header
        const firstMatch = allHeaderArrays.find(headers => headers.find(h => h.key === key));
        const header = firstMatch ? firstMatch.find(h => h.key === key) : null;
        if (header) common.push({ key: header.key, value: header.value });
      }
    }
    return common;
  };

  handleSelectAll = () => {
    this.setState(prevState => {
      const { selectedAll, selectedRequests } = prevState;

      const updatedSelectedRequests = Object.entries(selectedRequests).reduce((acc, [key, value]) => {
        acc[key] = !selectedAll;
        return acc;
      }, {});

      return {
        selectedRequests: updatedSelectedRequests,
        selectedAll: !selectedAll
      };
    });
  };

  validate = () => {
    const { requests, selectedRequests } = this.state;
    if (requests && Object.values(selectedRequests).some(value => value)) {
      return true;
    }

    return false;
  };

  getSelectedCount = () => {
    const { selectedRequests } = this.state;
    return Object.values(selectedRequests).filter(Boolean).length;
  };

  render() {
    const { requests, selectedRequests, selectedAll, fileName } = this.state;

    return (
      <div className="postman-uploader-container">
        {/* Header */}
        <div className="postman-uploader-header">
          <div className="postman-uploader-header-icon">
            <i className="fas fa-file-import"></i>
          </div>
          <div className="postman-uploader-header-text">
            <h3>Upload Postman Collection</h3>
            <p>Import API requests from your Postman collection file</p>
          </div>
        </div>

        {/* Body */}
        <div className="postman-uploader-body">
          {/* File Upload Zone */}
          <div className={`postman-file-upload-zone ${requests ? 'has-file' : ''}`}>
            {!requests ? (
              <>
                <div className="postman-upload-icon">
                  <i className="fas fa-cloud-upload-alt"></i>
                </div>
                <h4>Drop your collection file here</h4>
                <p>or click to browse from your computer</p>
                <label className="postman-browse-btn">
                  <i className="fas fa-folder-open"></i>
                  Select File
                  <input
                    type="file"
                    accept=".json,.postman_collection"
                    onChange={this.handleFileChange}
                    style={{ display: "none" }}
                  />
                </label>
              </>
            ) : (
              <div className="postman-file-selected">
                <div className="postman-file-selected-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div className="postman-file-selected-info">
                  <h5>{fileName}</h5>
                  <span>Collection loaded successfully</span>
                </div>
                <label className="postman-browse-btn" style={{ marginLeft: 'auto' }}>
                  <i className="fas fa-sync-alt"></i>
                  Change File
                  <input
                    type="file"
                    accept=".json,.postman_collection"
                    onChange={this.handleFileChange}
                    style={{ display: "none" }}
                  />
                </label>
              </div>
            )}
          </div>

          {/* Requests Table */}
          {requests && (
            <div className="postman-table-section">
              <div className="postman-table-header-bar">
                <div className="postman-table-title">
                  <i className="fas fa-list"></i>
                  <span>API Requests</span>
                </div>
                <div className="postman-table-count">
                  {this.getSelectedCount()} of {requests.length} selected
                </div>
              </div>
              <div className="postman-table-wrapper">
                <table className="postman-table">
                  <thead>
                    <tr>
                      <th className="col-checkbox">
                        <input
                          type="checkbox"
                          className="postman-checkbox"
                          checked={selectedAll}
                          onChange={() => this.handleSelectAll()}
                        />
                      </th>
                      <th className="col-name">Name</th>
                      <th className="col-type" style={{ width: 70, textAlign: 'center' }}>Type</th>
                      <th className="col-curl">cURL / Query</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requests.map((requestItem, index) => {
                      const isGql = requestItem.request?.body?.mode === "graphql";
                      const preview = isGql
                        ? (requestItem.request.body.graphql?.query || "").substring(0, 80)
                        : (requestItem.curlCommand || "").substring(0, 80);
                      return (
                      <tr key={index}>
                        <td className="col-checkbox">
                          <input
                            type="checkbox"
                            className="postman-checkbox"
                            checked={selectedRequests[index]}
                            onChange={() => this.handleCheckboxChange(index)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="postman-table-input"
                            value={requestItem.name}
                            onChange={e => this.handleNameChange(index, e.target.value)}
                          />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {isGql ? (
                            <span style={{
                              padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700,
                              background: 'rgba(139, 92, 246, 0.2)', color: '#a78bfa'
                            }}>GQL</span>
                          ) : (
                            <span style={{
                              padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700,
                              background: 'rgba(59, 130, 246, 0.2)', color: '#93c5fd'
                            }}>REST</span>
                          )}
                        </td>
                        <td>
                          <span className="postman-curl-preview" title={isGql ? requestItem.request.body.graphql?.query : requestItem.curlCommand}>
                            {preview.length >= 80 ? preview + "..." : preview}
                          </span>
                        </td>
                      </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="postman-uploader-footer">
          <button onClick={this.props.close} type="button" className="postman-btn postman-btn-cancel">
            Cancel
          </button>
          <button
            disabled={!this.validate()}
            onClick={() => this.createApis()}
            type="submit"
            className="postman-btn postman-btn-primary"
          >
            <i className="fas fa-plus"></i>
            Import APIs
          </button>
        </div>
      </div>
    );
  }
}

export default PostmanCollectionUploader;
